<template lang="pug">
.res-confirm
  .confirm
    confirm-card
</template>
<script>
import ConfirmCard from '@/components/res/ConfirmCard'
export default {
  name: 'ResConfirm',
  components: { ConfirmCard },
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.res-confirm
  width: 100%
  height: 100%
  //display: flex
  //justify-content: center
  //align-items: start
  .confirm
    margin-left: -2.5%
    width: 105%
    height: pxToRem(810)
</style>
